import {getQueryParam} from 'src/utils/url';
class KeepShopping {
  constructor() {
    this.compositeId = getQueryParam('cid');
    this.digest = getQueryParam('digest');
  }

  isEligible() {
    if (!ProductCatalog.IFrame.isIframer('ndx')) {
      return false;
    }
    if (getQueryParam('keep_shopping') === null) {
      return false;
    }
    if (!this.validCidParam()) {
      return false;
    }
    return true;
  }

  validCidParam() {
    return this.compositeId !== null && this.compositeId.length === 14;
  }
}

ProductCatalog.KeepShopping = new KeepShopping();
